import { Button, Flex, Stack, Tag } from '@chakra-ui/react';
import useDsbFormsQuery from 'hooks/useDsbFormsQuery';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AiFillCar } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { DataTable } from '../../components/Table/DataTable';
import useDsbFormQuery from '../../hooks/useDsbFormQuery';
import { ContentCard } from '../../layout/ContentCard';

const FormVersionDetails = ({ formId }: { formId: number }) => {
  const { t } = useTranslation();

  const dsbFormsQuery = useDsbFormsQuery();
  const dsbFormQuery = useDsbFormQuery(formId);
  const navigate = useNavigate();

  const formVersion = dsbFormQuery.data?.dsb_form_versions;

  const columns = useMemo(
    () => [
      {
        Header: t('pages:config_forms.table.columns.id'),
        accessor: 'id',
      },
      {
        Header: t('pages:config_forms.version'),
        accessor: 'version',
      },
      {
        Header: t('pages:config_forms.table.columns.status_tag'),
        accessor: 'published_at',
        // @ts-ignore
        Cell: ({ value }) => (
          <Tag variant={'solid'} size={'md'} padding={'6px'} colorScheme={isNil(value) ? 'gray' : 'green'}>
            {t(isNil(value) ? 'common:unpublished' : 'common:published').toUpperCase()}
          </Tag>
        ),
      },
      {
        id: 'details',
        accessor: 'id',
        // @ts-ignore
        Cell: (cellProps) => {
          const { row } = cellProps;

          return (
            <Flex alignContent={'flex-end'}>
              <Button
                ml={'auto'}
                variant={'primary'}
                onClick={() => {
                  navigate(`/app/op/dsb-form-version/${row?.original.id}`);
                }}
              >
                {t('common:details')}
              </Button>
            </Flex>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formVersion],
  );
  if (dsbFormsQuery.isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <ContentCard
      isLoading={dsbFormQuery.isFetching}
      icon={<AiFillCar size={'40px'} />}
      minH="fit-content"
      header={t('pages:config_forms.table.header_form_versions')}
      data-test-id="form-versions-details-card"
    >
      <Stack direction={['column', 'row']} w={'100%'}>
        <Stack direction="column" w={'100%'}>
          <DataTable
            data-test-id="forms-table"
            data={formVersion as unknown as any[]}
            hasFilters={false}
            hasSearchInput={false}
            columns={columns}
            loading={dsbFormQuery.isFetching}
            isMoreThenOnePage={false}
          />
        </Stack>
      </Stack>
    </ContentCard>
  );
};

export default FormVersionDetails;
